import { render, staticRenderFns } from "./RelationExtraction.vue?vue&type=template&id=7747b0fb&"
import script from "./RelationExtraction.vue?vue&type=script&lang=js&"
export * from "./RelationExtraction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports